import type { ButtonKind } from "../../Styles/Buttons";
import { ButtonRadioButtonGroup } from "./RadioButtonGroup/ButtonRadioButtonGroup";
import { HorizontalRadioButtonGroup } from "./RadioButtonGroup/HorizontalRadioButtonGroup";
import { VerticalRadioButtonGroup } from "./RadioButtonGroup/VerticalRadioButtonGroup";

export interface RadioButtonGroupOption {
  value: string | number;
  label: string;
  icon?: React.ReactNode;
  description?: React.ReactNode;
  /** Button variant only: `kind` when this option is selected (default `secondary`). */
  selectedKind?: ButtonKind;
  /** Extra classes on the label (e.g. `text-sm`). Button variant only. */
  labelClassName?: string;
}

export interface RadioButtonGroupProps {
  name: string;
  value: string | number;
  onChange: (e: { target: { value: string | number } }) => void;
  options: RadioButtonGroupOption[];
  variant?: "horizontal" | "vertical" | "button";
  error?: string;
  disabled?: boolean;
  /** Button variant only: tighter padding and intrinsic width. */
  compact?: boolean;
}

export const RadioButtonGroup: React.FC<RadioButtonGroupProps> = ({
  name,
  value,
  onChange,
  options,
  variant = "horizontal",
  error,
  disabled,
  compact,
}) => {
  switch (variant) {
    case "button":
      return (
        <ButtonRadioButtonGroup
          name={name}
          value={value}
          onChange={onChange}
          options={options}
          disabled={disabled}
          compact={compact}
        />
      );
    case "horizontal":
      return (
        <HorizontalRadioButtonGroup
          name={name}
          value={value}
          onChange={onChange}
          options={options}
          error={error}
          disabled={disabled}
        />
      );
    case "vertical":
      return (
        <VerticalRadioButtonGroup
          name={name}
          value={value}
          onChange={onChange}
          options={options}
          error={error}
          disabled={disabled}
        />
      );
    default:
      throw new Error(`Invalid variant for RadioButtonGroup: ${variant}`);
  }
};
